import { apiRequest } from './apiClient';

export const BEKLEYEN_ISLEM_YENILE_EVENT = 'bekleyen-islem-yenile';

export const fetchBekleyenIslemler = async ({ sayfa = 1, limit = 25, arama, modul, tur } = {}) => {
  const query = { sayfa, limit };
  if (arama) query.arama = arama;
  if (modul) query.modul = modul;
  if (tur) query.tur = tur;
  return apiRequest('/api/admin/bekleyen-islemler', { method: 'GET', query });
};

export const fetchBekleyenIslemOzet = async () => {
  return apiRequest('/api/admin/bekleyen-islemler/ozet', { method: 'GET', skipCsrf: true });
};

export const fetchBekleyenIslemTercih = async () => {
  return apiRequest('/api/admin/bekleyen-islemler/tercih', { method: 'GET', skipCsrf: true });
};

export const saveBekleyenIslemTercih = async ({ hakedisBekleyenGoster }) => {
  return apiRequest('/api/admin/bekleyen-islemler/tercih', {
    method: 'PATCH',
    body: { hakedisBekleyenGoster },
  });
};

export const dispatchBekleyenIslemYenile = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(BEKLEYEN_ISLEM_YENILE_EVENT));
  }
};

export const buildHedefSearch = (query = {}) => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value != null && String(value).trim() !== '') {
      params.set(key, String(value).trim());
    }
  });
  const s = params.toString();
  return s ? `?${s}` : '';
};
